import React from 'react';
import './ComponentCss/AllPaymentChip.css'; // 스타일을 위한 CSS 파일(Optional)
import AllIcon from '../Image/AllIcon.png';

const AllPaymentChip = ({ onClick ,listCount}) => {
    const handleClick = () => {
        // 부모에서 전달한 onClick 함수 호출
        if (onClick) {
            onClick();  // toggleBox가 호출될 것입니다.
        }
    };

    return (
        <button className="chip" onClick={handleClick}>
            <img className={'AllIcon'} src={AllIcon} alt="See more"/>
            <div className={'AllPaymentChip-Text'}>전체 미납내역</div>
            <button className={'AllPaymentChip-seemore-box1'}></button>
            <div className={'AllPaymentChip-seemore-box'}>
                <div className={'AllPaymentChip-count-box'}>{listCount}</div>
            </div>
        </button>
    );
};

export default AllPaymentChip;
